export default __webpack_public_path__ + "static/media/landingpage_desktop.a5157f69.png";